import { useRef, useState } from "react";
import axios from "axios";
import { CaptchaWidget } from "../../../components/CaptchaWidget/CaptchaWidget";
import { PLATFORM_LOGIN_URL } from "../../../features/UrlHelper";
import { publicAsset } from "../../../features/tenantPath";
import { useAuth } from "../../../context/AuthContext";

/**
 * Prihlasenie do platformovej spravy. Pusti LEN platformove ucty
 * (users.company_id IS NULL, rola SUPERADMIN) -- tenant login ich nevidi
 * a naopak.
 */
function PlatformLogin() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null);
  const [chyba, setChyba] = useState("");
  const [odosiela, setOdosiela] = useState(false);
  const turnstileRef = useRef(null);

  const odosli = async (e) => {
    e.preventDefault();
    setChyba("");
    if (!captchaToken) {
      setChyba("Prosím, potvrďte, že nie ste robot.");
      return;
    }
    setOdosiela(true);
    try {
      const res = await axios.post(PLATFORM_LOGIN_URL, { username, password, cfTurnstileToken: captchaToken });
      login(res.data);
    } catch (err) {
      setChyba(err?.response?.data?.message || "Prihlásenie zlyhalo.");
      turnstileRef.current?.reset?.();
      setCaptchaToken(null);
    } finally {
      setOdosiela(false);
    }
  };

  return (
    <main className="platform-login">
      <form className="platform-login__card" onSubmit={odosli}>
        <img src={publicAsset("rozvozy_icon.png")} height="40" alt="Rozvozy" />
        <h1 className="platform-login__title">Správa systému</h1>
        <label className="admin__form-field">
          <span className="admin__form-label">Prihlasovacie meno</span>
          <input
            className="admin__form-input"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            required
            autoFocus
          />
        </label>
        <label className="admin__form-field">
          <span className="admin__form-label">Heslo</span>
          <input
            className="admin__form-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </label>
        <CaptchaWidget onVerify={setCaptchaToken} turnstileRef={turnstileRef} />
        {chyba && <p className="platform-login__error" role="alert">{chyba}</p>}
        <button type="submit" className="platform-login__btn" disabled={odosiela}>
          {odosiela ? "Prihlasujem..." : "Prihlásiť sa"}
        </button>
      </form>
    </main>
  );
}

export default PlatformLogin;
